import React from 'react';
import './PhotoGrid.css';
import { Photo } from '../types';

interface PhotoGridProps {
  photos: Photo[];
}

const PhotoGrid: React.FC<PhotoGridProps> = ({ photos }) => {
  return (
    <div className="photo-grid">
      {photos.map((photo, index) => (
        <div 
          key={index}
          className="photo-item"
          style={{ background: photo.gradient }}
        >
          <img src={photo.url} alt={photo.alt} />
        </div>
      ))}
    </div>
  );
};

export default PhotoGrid;